import { Button, Container, Header, Modal, SpaceBetween, Box } from '@amzn/awsui-components-core';
import React from 'react';

/**
 * Modal component shown when the user's session has expired
 * Provides option to reload the page to re-authenticate
 */
interface SessionExpiredModalProps {
  visible: boolean;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ visible }) => {
  const handleRefresh = (): void => {
    window.location.reload();
  };

  // Don't render anything if not visible
  if (!visible) {
    return null;
  }

  return (
    <Modal
      visible={true}
      closeAriaLabel="Close"
      size="medium"
      header={<Header variant="h2">Session Expired</Header>}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary" onClick={handleRefresh} data-testid="refresh-button">
              Refresh to Sign in
            </Button>
          </SpaceBetween>
        </Box>
      }
      data-testid="session-expired-modal"
    >
      <Container>
        <SpaceBetween size="m">
          <Box variant="p">Your session has expired. Please refresh the page to sign in again.</Box>
        </SpaceBetween>
      </Container>
    </Modal>
  );
};

export default SessionExpiredModal;
